<!-- bagitem.component.html -->
<app-toast></app-toast>

<div class="gift-list-container">
    <!-- 載入狀態 -->
    <div *ngIf="loading" class="loading-overlay">
        <div class="spinner"></div>
        <p>載入中...</p>
    </div>

    <!-- 主要內容 -->
    <div *ngIf="!loading">
        <!-- 頂部操作欄 -->
        <div class="header-actions">
            <h2 class="page-title">背包物品主檔</h2>
            <div class="action-buttons">
                <button class="btn-primary" (click)="addNewItem()">
                    <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    新增物品
                </button>

                <button class="btn-secondary" (click)="refreshList()">
                    <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                    </svg>
                    重新載入
                </button>
            </div>
        </div>

        <!-- 篩選區域 -->
        <div class="filter-section">
            <div class="search-bar">
                <input
                    type="text"
                    placeholder="搜尋物品名稱..."
                    [(ngModel)]="searchTerm"
                    (keyup.enter)="searchList()"
                    class="search-input"
                />
                <svg class="search-icon" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                </svg>
            </div>

            <button class="btn-primary" (click)="searchList()">搜尋</button>

            <div class="result-count">
                共 {{ pageobj.total_count }} 筆
            </div>
        </div>

        <!-- 列表視圖 -->
        <div class="gift-list">
            <div class="list-header">
                <div class="col-image">圖片</div>
                <div class="col-name">名稱</div>
                <div class="col-emoji">emoji</div>
                <div class="col-des">說明</div>
                <div class="col-points">點數</div>
                <div class="col-gender">性別</div>
                <div class="col-type">類型</div>
                <div class="col-status">狀態</div>
                <div class="col-dt">起始</div>
                <div class="col-dt">結束</div>
                <div class="col-actions">操作</div>
            </div>

            <div
                *ngFor="let item of items; trackBy: trackByItemId"
                class="list-item"
                [class.disabled]="item.status !== '1'"
            >
                <div class="col-image">
                    <img loading="lazy" [src]="item.pic" [alt]="item.name" class="list-image" (error)="onImageError($event)" />
                </div>
                <div class="col-name">
                    <div class="name-with-id">
                        <strong>{{ item.name }}</strong>
                        <small>ID: {{ item.id }}</small>
                    </div>
                </div>
                <div class="col-emoji">{{ item.emoji }}</div>
                <div class="col-des">{{ item.des_action }}</div>
                <div class="col-points">{{ numberToThousand(item.points) }}</div>
                <div class="col-gender">{{ getGenderText(item.gender) }}</div>
                <div class="col-type">{{ getTypeText(item.type) }}</div>
                <div class="col-status">
                    <span class="status-badge" [ngClass]="getStatusClass(item.status)">
                        {{ getStatusText(item.status) }}
                    </span>
                </div>
                <div class="col-dt">{{ formatDate(item.start_dt) }}</div>
                <div class="col-dt">{{ formatDate(item.end_dt) }}</div>
                <div class="col-actions">
                    <button class="action-btn edit" (click)="editItem(item)" title="編輯">
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708L10.5 8.207l-3-3L12.146.146zM11.207 9L8 5.793 1.146 12.646a.5.5 0 0 0-.146.354v2.5a.5.5 0 0 0 .5.5h2.5a.5.5 0 0 0 .354-.146L11.207 9z"/>
                        </svg>
                    </button>
                    <button class="action-btn toggle" [class.enable]="item.status === '1'" (click)="toggleStatus(item)" title="上下架">
                        <svg *ngIf="item.status === '1'" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.061L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                        </svg>
                        <svg *ngIf="item.status !== '1'" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </button>
                    <button class="action-btn delete" (click)="deleteItem(item)" title="刪除">
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                            <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <!-- 空狀態 -->
        <div *ngIf="items.length === 0 && !loading" class="empty-state">
            <h3>沒有找到物品</h3>
            <p>{{ searchTerm ? '嘗試調整搜尋條件' : '目前沒有任何背包物品資料' }}</p>
            <button class="btn-primary" (click)="addNewItem()">新增第一個物品</button>
        </div>

        <!-- 分頁 -->
        <app-pagnation
            *ngIf="pageobj.total_count > 0"
            [data]="pageobj"
            (callback)="handlepage($event)"
        ></app-pagnation>
    </div>
</div>

<!-- 新增 / 編輯彈窗 -->
<div *ngIf="showItemModal" class="modal-overlay" (click)="onModalBackdropClick($event)">
    <div class="modal-container">
        <div class="modal-header">
            <h3 class="modal-title">{{ isEditMode ? '編輯物品' : '新增物品' }}</h3>
            <button class="modal-close" (click)="closeItemModal()">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <form class="edit-form" (ngSubmit)="save()">
                <!-- 基本資訊區塊 -->
                <div class="form-section">
                    <h4 class="section-title">基本資訊</h4>
                    <div class="form-grid">
                        <div class="form-group">
                            <label class="form-label">物品名稱 <span class="required">*</span></label>
                            <input
                                type="text"
                                class="form-input"
                                [(ngModel)]="editForm.name"
                                name="name"
                                placeholder="請輸入物品名稱"
                                maxlength="30"
                                required
                            />
                        </div>

                        <div class="form-group">
                            <label class="form-label">說明</label>
                            <input
                                type="text"
                                class="form-input"
                                [(ngModel)]="editForm.des_action"
                                name="des_action"
                                placeholder="請輸入說明"
                                maxlength="100"
                            />
                        </div>

                        <div class="form-group">
                            <label class="form-label">emoji</label>
                            <input
                                type="text"
                                class="form-input"
                                [(ngModel)]="editForm.emoji"
                                name="emoji"
                                placeholder="藍新儲值頁圖案"
                                maxlength="10"
                            />
                        </div>

                        <div class="form-group">
                            <label class="form-label">物品價值(點數) <span class="required">*</span></label>
                            <input
                                type="number"
                                class="form-input"
                                [(ngModel)]="editForm.points"
                                name="points"
                                placeholder="0"
                                min="0"
                                required
                            />
                        </div>

                        <div class="form-group">
                            <label class="form-label">性別</label>
                            <select class="form-select" [(ngModel)]="editForm.gender" name="gender">
                                <option *ngFor="let o of genderOptions" [value]="o.value">{{ o.label }}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label class="form-label">類型</label>
                            <select class="form-select" [(ngModel)]="editForm.type" name="type">
                                <option *ngFor="let o of typeOptions" [value]="o.value">{{ o.label }}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label class="form-label">狀態</label>
                            <div class="radio-group">
                                <label class="radio-item">
                                    <input type="radio" [(ngModel)]="editForm.status" name="status" value="1" />
                                    <span class="radio-label">上架</span>
                                </label>
                                <label class="radio-item">
                                    <input type="radio" [(ngModel)]="editForm.status" name="status" value="0" />
                                    <span class="radio-label">停用</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 期間設定區塊 -->
                <div class="form-section">
                    <h4 class="section-title">期間設定</h4>
                    <div class="form-grid">
                        <div class="form-group">
                            <label class="form-label">起始時間</label>
                            <input
                                type="datetime-local"
                                class="form-input"
                                [(ngModel)]="editForm.start_dt"
                                name="start_dt"
                            />
                        </div>
                        <div class="form-group">
                            <label class="form-label">結束時間</label>
                            <input
                                type="datetime-local"
                                class="form-input"
                                [(ngModel)]="editForm.end_dt"
                                name="end_dt"
                            />
                        </div>
                    </div>
                </div>

                <!-- 圖片上傳區塊 -->
                <div class="form-section">
                    <h4 class="section-title">物品圖片 {{ !isEditMode ? '*' : '' }}</h4>

                    <div class="image-upload-container">
                        <!-- 有圖片時的顯示 -->
                        <div class="current-image" *ngIf="imagePreviewUrl">
                            <img loading="lazy" [src]="imagePreviewUrl" [alt]="editForm.name" class="image-display"
                                 (error)="onImageError($event)" />
                            <div class="image-actions">
                                <button type="button" class="upload-btn" (click)="fileInput.click()">
                                    {{ selectedFile ? '更換圖片' : (isEditMode ? '上傳新圖片' : '選擇圖片') }}
                                </button>
                                <button type="button" class="reset-btn" (click)="resetImage()" *ngIf="selectedFile || !isEditMode">
                                    {{ isEditMode && editingItem ? '恢復原圖' : '移除圖片' }}
                                </button>
                            </div>
                        </div>

                        <!-- 沒有圖片時的上傳區域 -->
                        <div class="upload-area" *ngIf="!imagePreviewUrl">
                            <div class="upload-content" (click)="fileInput.click()">
                                <div class="upload-icon">
                                    <svg width="48" height="48" fill="#667eea" viewBox="0 0 16 16">
                                        <path d="M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2V3zm1 9v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12zm5-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"/>
                                    </svg>
                                </div>
                                <p class="upload-text">點擊選擇物品圖片</p>
                                <p class="upload-hint">支援 JPG、PNG、GIF 格式，大小不超過 5MB</p>
                            </div>
                        </div>

                        <!-- 隱藏的檔案輸入 -->
                        <input
                            type="file"
                            #fileInput
                            style="display: none;"
                            accept="image/*"
                            (change)="onFileSelected($event)"
                        />
                    </div>
                </div>
            </form>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn-cancel" (click)="closeItemModal()">取消</button>
            <button type="button" class="btn-save" (click)="save()" [disabled]="isUploading">
                {{ isUploading ? '儲存中...' : (isEditMode ? '保存' : '新增物品') }}
            </button>
        </div>
    </div>
</div>
